import { render, staticRenderFns } from "./ServiceAnalytics.vue?vue&type=template&id=3bc344c5&"
import script from "./ServiceAnalytics.vue?vue&type=script&setup=true&lang=js&"
export * from "./ServiceAnalytics.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports